type Payload = Record<string, string | string[] | boolean | File>;

export const buildFormData = (payload: Payload) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
    } else if (typeof value === 'boolean') {
      formData.append(key, String(value));
    } else {
      formData.append(key, value);
    }
  });
  return formData;
};
